import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { PawPrint, ArrowRight } from "@phosphor-icons/react";

const STORY_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/062e260e-b0f9-432f-a759-5890d554bb91/images/39d7006d34192de75beb02c0f1b48f72318abca8410591c9e1e63fef7d544981.jpeg";

export default function OriginStory() {
  return (
    <section className="relative bg-black border-y border-white/5 overflow-hidden" data-testid="origin-story">
      <div className="grain absolute inset-0 opacity-60" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 grid lg:grid-cols-2 gap-14 items-center">
        {/* B&W image */}
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-[12px] overflow-hidden border border-white/10"
          data-testid="origin-image"
        >
          <img
            src={STORY_IMAGE}
            alt="Smiley, Beats and King — the babies"
            className="w-full aspect-[4/3] object-cover"
            style={{ filter: "grayscale(1) contrast(1.05)" }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          <span className="absolute bottom-4 left-4 overline text-white/80" data-testid="origin-caption">
            Smiley · Beats · King — the babies
          </span>
        </motion.div>

        {/* Story */}
        <div>
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="overline text-white/60 mb-4"
          >
            The Origin · In black &amp; white
          </motion.p>

          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.05 }}
            className="font-display text-4xl sm:text-5xl leading-[0.95] mb-6"
          >
            It started with <span className="lowercase">wiggle</span><span className="neon-text">S</span>.
          </motion.h2>

          <div className="space-y-5 text-white/70 leading-relaxed max-w-xl">
            <p>
              Before the drops, before the hypercolor, there were the babies —
              <span className="text-white"> Smiley</span>, the white pit with the softest soul;
              <span className="text-white"> Beats</span>, the grey mastiff-pit who ran the block;
              and <span className="text-white"> King</span>, the blue-nose grey with the white diamond on his chest.
              They were family. They were the whole reason.
            </p>
            <p>
              We lost them. But every stitch of Mr. Wigglez carries them forward — the loud fits, the neon,
              the pack energy. They live in the aura. <span className="text-white">RIP. 🕊️</span>
            </p>
            <p className="border-l-2 border-primary pl-5 text-white">
              So we made a promise: turn the pain into a purpose. Build a ranch. Save the ones nobody wanted.
              <span className="neon-text"> $3M. 300 acres. 3,000 pits rescued.</span>
            </p>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/rescue"
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-[10px] font-modern font-medium hover:bg-primary/90 transition-colors"
              data-testid="origin-rescue-btn"
            >
              <PawPrint weight="fill" size={16} /> Meet the pack we&apos;re saving
            </Link>
            <Link
              to="/hub"
              className="inline-flex items-center gap-2 border border-white/20 text-white px-6 py-3 rounded-[10px] font-modern hover:bg-white/5 transition-colors"
              data-testid="origin-hub-btn"
            >
              The movement <ArrowRight size={15} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
